/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import Banner from "../../../components/passenger/stationDetail/Banner";
import Header from "../../../components/common/layout/Header";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import useAxios from "../../../shared/hooks/use-axios";
import { dataActions } from "../../../shared/store/data-Slice";
import { url } from "../../../shared/utils/url";
import { TrainSvg, EntryExitSvg, LiftSvg, PlatformSvg, TicketSvg, FacilitiesSvg, StoreSvg, NearbyAttractionsSvg, NearbySvg } from '../../../components/common/svg/AllSvg';
import GatesDetails from "../../../components/passenger/stationDetail/GatesDetails";
import LiftDetails from "../../../components/passenger/stationDetail/LiftDetails";
import PlatformsDetails from "../../../components/passenger/stationDetail/PlatformsDetails";
import TicketCounter from "../../../components/passenger/stationDetail/TicketCounter";
import StationsFacilities from "../../../components/passenger/stationDetail/StationsFacilities";
import StoresAtStations from "../../../components/passenger/stationDetail/StoresAtStations";
import NearByPlaces from "../../../components/passenger/stationDetail/NearByPlaces";
import StationDetails from "../../../components/passenger/stationDetail/StationDetails";
import NearByAttractions from "../../../components/passenger/stationDetail/NearByAttractions";
import PageLoader from "../../../components/common/layout/PageLoader";
import { Helmet } from "react-helmet";
import { sitemap } from "../../../shared/utils/sitemap";
import Error from "../../../components/common/form/Error";
import Canonical from "../../../components/common/layout/Canonical";

const StationDetail = () => {
    const theme: any = useSelector((state: any) => state.ui.theme);
    const { t } = useTranslation('common');
    const stationDetailData: any = useSelector((state: any) => state.data.stationDetailData);
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [activeMenu, setActiveMenu] = useState<string>("");
    const [stDetail, setStDetail] = useState<boolean>(false);
    const [category, setCategory] = useState<any[]>([]);
    const [store, setStore] = useState<any[]>([]);
    const [place, setPlace] = useState<boolean>(false);
    const [storeMenu, setStoreMenu] = useState<boolean>(false);
    const [select, setSelect] = useState<any>(null);
    const [menu, setMenu] = useState<any[]>([]);
    const [scrollY, setScrollY] = useState<boolean>(false);
    const [sticky, setSticky] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);
    const [isError, setIsError] = useState<boolean>(false)
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();

    let menuData: any[] = [
        { id: 1, icon: TrainSvg, name: t('passenger.station_detail.station_details'), eId: "facility", component: StationDetails },
        { id: 2, icon: EntryExitSvg, name: t('passenger.station_detail.entry_and_exit'), eId: "gates", component: GatesDetails },
        { id: 3, icon: LiftSvg, name: t('passenger.station_detail.lift_and_escalator'), eId: "lifts", component: LiftDetails },
        { id: 4, icon: PlatformSvg, name: t('passenger.station_detail.platforms'), eId: "platforms", component: PlatformsDetails },
        { id: 5, icon: TicketSvg, name: t('passenger.station_detail.ticket_counters'), eId: "ticket_counters", component: TicketCounter },
        { id: 6, icon: FacilitiesSvg, name: t('passenger.station_detail.station_facility'), eId: "station_facilities", component: StationsFacilities },
        { id: 7, icon: NearbySvg, name: t('passenger.station_detail.nearby_places'), eId: "nearby_places", component: NearByPlaces }
    ]

    const getStationDetails = async () => {
        try {
            setLoading(true)
            setIsError(false)
            dispatch(dataActions.setStationDetailData(null))
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.stationDetail}${params?.code}/`);

            if (res && res?.status === 200) {
                dispatch(dataActions.setStationDetailData(res?.data))

                if (Object.keys(res?.data)?.length > 0) {
                    let arr: any[] = [];
                    for (let j = 0; j < menuData?.length; j++) {
                        const m = menuData[j];

                        if (m?.eId === "station_facilities" && (res?.data?.[m?.eId]?.length > 0 || res?.data?.["parkings"]?.length > 0)) {
                            arr.push(m)
                        }

                        if (res?.data?.[m?.eId]?.length > 0 && m?.eId !== "station_facilities") {
                            arr.push(m)
                        }

                        if (res?.data?.[m?.eId]?.length > 0 && m?.eId === "nearby_places") {
                            let places: any[] = []
                            for (let i = 0; i < res?.data?.[m?.eId].length; i++) {
                                const el = res?.data?.[m?.eId][i];

                                if (el?.show_in_tourist) {
                                    places.push(el)
                                }
                            }

                            if (places?.length > 0) {
                                arr.push({ id: 8, icon: NearbyAttractionsSvg, name: t('passenger.station_detail.nearby_attractions'), eId: "nearby_attractions", component: NearByAttractions })
                                setPlace(true)
                            }
                        }
                    }
                    setMenu(arr)
                    arr?.length > 0 ? setActiveMenu(arr[0]?.eId) : setActiveMenu("")
                    setStDetail(true)
                    setLoading(false)
                }

                if (res?.data === "No Station Exists") {
                    (!!params?.lang ? navigate(`/${params?.lang}/404`) : navigate("/404"))
                } else {
                    sitemap()
                }
            }
        } catch (error) {
            setIsError(true)
            setLoading(false)
            dispatch(dataActions.setStationDetailData(null))
            console.error("error while feching stations data", error);
        }
    };

    useEffect(() => {
        (!!params?.code && !!lang) && getStationDetails();
    }, [lang, params?.code])

    // useEffect(() => {
    //     !!lang && getStoreCategory();
    // }, [lang])

    // useEffect(() => {
    //     (!!params?.code && !!lang && stDetail && !!select) && getStore();
    // }, [lang, params?.code, stDetail, select])


    useEffect(() => {
        const handleScroll = () => {
            setTimeout(() => {
                if (window.scrollY > 400) {
                    setScrollY(true)
                }
                if (window.scrollY === 0) {
                    setScrollY(false)
                }
            }, 100)
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [window.scrollY])

    const getStoreCategory = async () => {
        try {
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.storeCategory}`);

            if (res && res?.status === 200) {
                if (res?.data?.length > 0) {
                    setCategory(res?.data)
                    !!!select && setSelect(res?.data?.[0])
                } else {
                    setCategory([])
                    setSelect(null)
                }
            }
        } catch (error) {
            console.error("error while feching store category", error);
        }
    }

    const getStore = async () => {
        try {
            const res: any = await useAxios.get(`/${(!!lang ? lang : "en") + url?.store}${params?.code}/${select?.id}`);

            if (res && res?.status === 200) {
                setStore(res?.data)
                if (!storeMenu) {
                    if (stationDetailData?.nearby_places?.length > 0) {
                        const newArr = [...menu];
                        const secondLastIndex = newArr.length - (place ? 2 : 1);
                        newArr.splice(secondLastIndex, 0, { id: 7, icon: StoreSvg, name: t('passenger.station_detail.store'), eId: "stores", component: StoresAtStations });
                        setMenu(newArr);
                    } else {
                        setMenu([...menu, { id: 7, icon: StoreSvg, name: t('passenger.station_detail.store'), eId: "stores", component: StoresAtStations }]);
                    }
                }
                setStDetail(false)
                setStoreMenu(true)
            }
        } catch (error) {
            console.error("error while feching store", error);
        }
    }

    useEffect(() => {
        setTimeout(() => {
            if (scrollY) {
                setSticky(true)
            } else {
                setSticky(false)
            }
        }, 100)
    }, [scrollY])

    return (
        <>
            <Canonical />
            <Helmet>
                <title>{lang === "en" ? `${!!stationDetailData?.commercial_name ? stationDetailData?.commercial_name : ''} Station Details | Facilities, Services, and Nearest gate` : lang === "hi" ? `${!!stationDetailData?.commercial_name ? stationDetailData?.commercial_name : ''} स्टेशन विवरण | सुविधाएँ, सेवाएँ, और निकटतम गेट` : `${!!stationDetailData?.commercial_name ? stationDetailData?.commercial_name : ''} स्थानकाचे तपशील | सुविधाएँ, सेवा, आणि जवळचा गेट`}</title>
                <meta name="description" content={lang === "en" ? `Get comprehensive details about ${!!stationDetailData?.commercial_name ? stationDetailData?.commercial_name : ''}, including facilities, services, nearest gate, and nearby attractions. Plan your journey efficiently with all the information you need.` : lang === "hi" ? `${!!stationDetailData?.commercial_name ? stationDetailData?.commercial_name : ''} के बारे में व्यापक जानकारी प्राप्त करें, जिसमें सुविधाएँ, सेवाएँ, निकटतम गेट, और आस-पास के आकर्षण शामिल हैं। सभी आवश्यक जानकारी के साथ अपनी यात्रा को प्रभावी ढंग से योजना बनाएं।` : `${!!stationDetailData?.commercial_name ? stationDetailData?.commercial_name : ''} बद्दल व्यापक माहिती मिळवा, ज्यामध्ये सुविधा, सेवा, जवळचा गेट, आणि आसपासच्या आकर्षणांचा समावेश आहे. तुम्हाला लागणारी सर्व माहितीसह तुमच्या प्रवासाची प्रभावीपणे योजना करा.`} />
            </Helmet>
            <div className="w-full h-full bg-white dark:bg-bgDarkDull">
                <div className={`${sticky ? "sticky" : ""} top-0 z-[2] ${(!loading && !isError) && "bg-[#F8F8F8]"}`}>
                    <div className={`w-full relative ${scrollY ? "h-[200px] xs:h-[150px] sm:h-[120px] mms:h-[84px]" : "h-[400px] xlx:h-[500px]"} transition-all duration-100`}>
                        {(!loading && !isError) && <img src={theme === "dark" ? require("../../../assets/images/dark-st-bg.png") : require("../../../assets/images/st-bg.png")} alt="st-bg" className="w-full h-full object-cover" />}
                        <div className={`absolute top-0 left-0 right-0 ${scrollY ? "hidden" : "block"}`}>
                            <Header type="passenger" />
                        </div>
                        {(!loading && !isError) && <Banner activeMenu={activeMenu} setActiveMenu={setActiveMenu} menu={menu} scrollY={scrollY} />}
                    </div>
                </div>

                {loading ?
                    <div className="w-full h-full mt-[-200px] xlx:mt-[-250px] mb-[50px] container">
                        <PageLoader />
                    </div>
                    : <div className="w-full h-full" id="home">
                        {isError ?
                            <div className="w-full h-full mt-[-200px] xlx:mt-[-250px] container">
                                <Error />
                            </div>
                            : <>
                                {Array.isArray(menu) && menu?.map((item: any, index: number) => (
                                    <React.Fragment key={index}>
                                        {item?.eId === "stores" ? <item.component setSelect={setSelect} store={store} category={category} select={select} setStDetail={setStDetail} /> : <item.component />}
                                    </React.Fragment>
                                ))}
                            </>}

                        <div className="bg-[#F6F9FC] dark:bg-[#0B121A] w-full h-full">
                            <div className="bg-white dark:bg-bgDarkDull rounded-b-[50px] lg:rounded-b-[80px] xl:rounded-b-[100px] xlx:h-[120px] h-[30px] lg:h-[80px]">

                            </div>
                        </div>
                    </div>}
            </div >
        </>
    );
};

export default StationDetail;